import React from 'react';

/**
 * Top Threats chart component - horizontal bar chart showing threats by max risk
 * @param {Object} props
 * @param {Array} props.data - Array of {threat_id, threat_name, max_risk}
 */
export default function TopThreatsChart({ data = [] }) {
  if (data.length === 0) {
    return (
      <div className="text-center py-8 text-slate-500 text-sm">
        No threat data available
      </div>
    );
  }

  const maxRisk = Math.max(...data.map(t => t.max_risk || 0), 1);
  
  // Color coding based on risk level (1-5 scale)
  const getRiskColor = (risk) => {
    if (risk >= 4.5) return '#dc2626'; // Critical - red
    if (risk >= 3.5) return '#fb923c'; // High - orange
    if (risk >= 2.5) return '#facc15'; // Moderate - yellow
    if (risk >= 1.5) return '#38bdf8'; // Low - sky blue
    return '#94a3b8'; // Info - slate
  };

  return (
    <div className="w-full">
      <div className="space-y-2">
        {data.map((threat) => {
          const risk = threat.max_risk || 0;
          const widthPercent = maxRisk > 0 ? (risk / maxRisk) * 100 : 0;
          const color = getRiskColor(risk);

          return (
            <div key={threat.threat_id} className="flex items-center gap-3">
              <div className="w-40 text-xs font-medium text-slate-600 truncate text-right" title={threat.threat_name}>
                {threat.threat_name}
              </div>
              <div className="flex-1 flex items-center gap-2">
                <div className="flex-1 h-2.5 bg-slate-100 rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full transition-all duration-700 ease-out"
                    style={{ width: `${widthPercent}%`, backgroundColor: color }}
                  />
                </div>
                <span className="text-xs font-bold text-slate-500 w-8 text-right tabular-nums">
                  {risk.toFixed(1)}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
